import { Base } from "../../framework/base";
import { UserType } from "../enums";

export interface ISortModifyUsersParams {
    column?: string;
    asc?: boolean;
    currentUserCode?: string;
}

export interface IModifyUser {
    code: string;
    name: string;
    date: number;
    picture: string;
    userType: UserType;

    isRemoved(): boolean;
}

export class ModifyUser implements IModifyUser {
    code: string;
    name: string;
    date: number;
    picture: string;
    userType: UserType;

    constructor();
    constructor(obj: IModifyUser);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.date = obj && obj.date || 0;
        this.picture = obj && obj.picture || "";
        this.userType = obj && obj.userType || UserType.Normal;
    }

    isRemoved(): boolean {
        return this.userType === UserType.Removed;
    }

    static createModifyUser(code: string, name: string, date: number, picture: string): IModifyUser {
        const result = new ModifyUser();
        result.code = code;
        result.name = name;
        result.date = date;
        result.picture = picture;
        result.userType = UserType.Normal;
        return result;
    }

    static sortModifyUsers(items: IModifyUser[], { column = "name", asc = true, currentUserCode = null }: ISortModifyUsersParams = { column: "name", asc: true, currentUserCode: null }): IModifyUser[] {
        if (!items && items.length < 2) return items;
        let result: IModifyUser[];
        if (column === "code") {
            result = items.sort((a: IModifyUser, b: IModifyUser) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.code, b.code)); });
        } else if (column === "date") {
            result = items.sort((a: IModifyUser, b: IModifyUser) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.date, b.date)); });
        } else {
            result = items.sort((a: IModifyUser, b: IModifyUser) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.name, b.name)); });
        }
        if (currentUserCode) {
            result = Base.moveToFirst(result, result.findIndex(i => i.code === currentUserCode));
        }
        return result;
    }
}

export class SaveModifyUser {
    code: string;
    date?: number;

    constructor();
    constructor(obj: IModifyUser);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.date = obj && obj.date || null;
    }
}